import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RedirectCard from "../../components/RedirectCard";

export default function Redirect() {
  const request = useLocation().state?.request;
  const message = useLocation().state?.message;
  const navigate = useNavigate();

  useEffect(() => {
    if (!request) {
      navigate("/form");
      return undefined;
    }

    return undefined;
  }, [request, navigate]);

  if (!request) return null;

  return (
    <div className="min-h-screen flex items-center justify-center">
      <RedirectCard request={request} message={message} />
    </div>
  );
}
